import { component } from 'picoapp'
import $ from '../lib/quantdom'

export default component((announcementBar) => {
  if (sessionStorage.getItem('announcement-bar-closed')) {
    $(announcementBar).hide(true)
  } else {
    $(announcementBar).show(true)
    $(announcementBar)
      .find('button[aria-label="close"]')
      .on('click', () => {
        $(announcementBar).hide(true)
        sessionStorage.setItem('announcement-bar-closed', 'true')
      })
  }
})
